/* eslint-disable no-unreachable */
/* eslint-disable no-else-return */
/* eslint-disable no-restricted-syntax */
import React, { useContext, useEffect, useState, useMemo } from "react";
import { useMutation, useQuery, useLazyQuery } from "@apollo/client";
import { List, Tag, Tooltip, message, Checkbox, Button, Modal, Collapse } from "antd";
import { ExportOutlined, PlusCircleFilled } from "@ant-design/icons";
import { capitalize, uniqBy, isString, orderBy, isEmpty } from "lodash";
import { LuPencil } from "react-icons/lu";

import { useDispatch, useSelector } from "react-redux";
import DownIcon from "../../../../icons/DownIcon";
import { UserContext } from "../../../../amplify/authenticator-provider";
import {
  UPDATE_LEAD_OPPORTUNITY,
  UPDATE_OPPORTUNITY_STAGE_NAME,
  PUSH_OPPORTUNITY_TO_DMS,
} from "../../../../graphql/mutation";
import { AccessPermissionAction } from "../../../../library/constants";
import { checkAccessPermission } from "../../../../library/helpers";
import useLang from "../../../../hooks/useLang";
import useCrm from "../../../../hooks/useCrm";
import { CRM_TYPE_LABELS, CRM_TYPES } from "../../../../constants/crmConstants";
import OpportunityWarning from "./opportuityWarning";
import { GET_OPPORTUNITY_STATUS_NEW, GET_OPPORTUNITTIES_TYPES } from "../../../../graphql/query";
import { getLeadOpportunitySource } from "../../leadSourceHelper";
import { getLeadOpportunityStatus } from "../../leadStatusHelper";
import "./opportunityLayer.css";
import { getUniqueVehicleOfInterest, getVehicleName } from "../engagementHelpers";
import MergeOpportunityDrawer from "./MergeOpportunityDrawer";
import { getHiddenDuplicateIds } from "./mergeOpportunityHelpers";
import {
  DuplicateRecordsBanner,
  MergedRecordsBanner,
  MERGED_PREVIEW_BG,
} from "../merge/MergeBanner";
import { MERGED_PREVIEW_OF } from "../merge/mergeRecordsHelpers";
import { OpportunityDrawer } from "./opportunityDrawer";
import CoBuyerCard from "./CoBuyerCard";
import AddCoBuyerDrawer from "./AddCoBuyerDrawer";
import { changeMessageOpportunity, setShowAll } from "../../../../redux/slices/leadSlice";
import { convertUtcToLocal } from "../../../../library/utils";
import { OpportunityStatusCascader } from "../../cascaders/OpportunityCascaders";
import InvoiceDetailsDrawer from "./InvoiceDetailsDrawer";
import OpportunityAssignmentDrawer from "../../OpportunityReassessment/OpportunityAssignmentDrawer";
import { DATE_TIME_FORMATS } from "../../../../utils/dateTimes";
import CustomDivider from "../../../commonComponents/divider";
import CustomButton from "../../../commonComponents/button";
import { getRootOppTypeId, oppMatchesTab } from "../../../../library/oppTypeScoping";
import { ALL_OPPORTUNITY_TYPES_ID } from "../../../../helpers/opportunityHelper";
import { getRootConfig, KNOWN_ROOT_IDS } from "../../../../library/oppTypeRootConfig";

// Top-right corner chip on each opp card showing that opp's root
// opp_type — visuals driven by ``ROOT_OPP_TYPES`` so adding Parts (or
// any new root) lights up the chip automatically. Anchored to the
// card's top-right corner with only the bottom-left rounded so the
// chip sits flush inside the card's outline. Returns null when the
// root can't be resolved (lead with no opp_type loaded into the
// GraphQL response) or the root isn't a configured one.
const OppTypeCardCornerIcon = ({ opp }) => {
  const rootId = getRootOppTypeId(opp?.opportunityType);
  if (!rootId || !KNOWN_ROOT_IDS.has(Number(rootId))) return null;
  const { Icon, stroke, chipBg } = getRootConfig(rootId);
  return (
    <span
      className="absolute right-0 top-0 flex items-center justify-center"
      style={{
        width: 20,
        height: 20,
        background: chipBg,
        borderBottomLeftRadius: 4,
      }}
    >
      <Icon size={13} color={stroke} strokeWidth={1.33} />
    </span>
  );
};

const SFOpprStatus = [
  {
    statusTypeId: "1",
    status: "Duplicate",
  },
];

const OpportunityLayer = props => {
  const {
    leadOpportunities,
    leadFullname,
    crmLeadObj,
    selectedLead,
    crmIntegrationType,
    crmIntegrationData,
    refetchLeads,
    allowChangeStatus = true,
    refetchLeadDetails,
    // Reloads the conversation thread. `refetchLeadDetails` deliberately
    // carries the existing `messages` array forward, so anything that makes
    // the BE post a message has to ask for the thread separately.
    getMessages = () => {},
    oppValue,
    setSelectedLead,
    getLeadOpportunities,
    // Opp-type-scoped tab — drives the client-side filter on the
    // opportunity card list. The tab strip itself moved up to
    // ``LeadProfile`` (``OppTypeRootTabs``); this component now just
    // reads the active id and scopes its cards.
    selectedOppTypeId,
    // Setter mirrored back to the root tab strip when the checkbox below
    // pins/unpins a specific opportunity — keeps TopToolbarJsx's chip
    // icon in sync with whichever opp is actually pinned.
    setSelectedOppTypeId,
  } = props;

  const { messageOpportunity } = useSelector(state => state.lead);
  const [lang] = useLang();
  const { getOpprDetails } = useCrm();
  const [statusId, setStatusId] = useState(selectedLead?.leadStatusTypeId);
  const [opportunityDrawer, setopportunityDrawer] = useState({
    open: false,
    item: {},
  });
  const [isSFOppr, setIsSfOppr] = useState(false);
  const [isDSOppr, setIsDsOppr] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isOpprOverall, setIsOpprOverall] = useState(false);
  const [list, setlist] = useState([]);
  const [listTemp, setListTemp] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [coBuyerDrawerOpen, setCoBuyerDrawerOpen] = useState(false);
  const [state, setState] = useState(false);

  const [opportunityWarningDialog, setOpportunityWarningDialog] = useState(false);
  const [opportunityInfo, setOpportunityInfo] = useState({});
  // Drawer state for the per-card "View N ROs" button. Holds the
  // currently-expanded LeadOpportunity row id; null ⇒ drawer closed.
  // DS-only today, but the component will gracefully handle empty
  // ``serviceRos`` lists once we widen to other DMSes.
  const [viewRosForOppId, setViewRosForOppId] = useState(null);
  const [selectedOpportunity, setSelectedOpportunity] = useState(oppValue);
  const { showAll } = useSelector(state => state.lead);

  const [invoiceDrawer, setInvoiceDrawer] = useState({
    open: false,
    invoiceData: null,
  });

  const [reassignDrawer, setReassignDrawer] = useState({
    open: false,
    opportunity: null,
  });

  // The opportunity whose duplicates are being merged (EAI-1815);
  // null ⇒ the merge drawer is closed.
  const [mergeOpportunity, setMergeOpportunity] = useState(null);

  const dispatch = useDispatch();
  const handleOpporDialogFlagChanged = () => {
    localStorage.setItem("isOpporDialogFlagChangedLocal", "true");
  };

  const { user } = useContext(UserContext);

  const [updateSFStage] = useMutation(UPDATE_OPPORTUNITY_STAGE_NAME);
  const [updateLeadOpportunity] = useMutation(UPDATE_LEAD_OPPORTUNITY);
  const [pushOpportunityToDms] = useMutation(PUSH_OPPORTUNITY_TO_DMS);

  const settings = useMemo(() => {
    if (selectedLead?.location?.settings) {
      return isString(selectedLead?.location?.settings)
        ? JSON.parse(selectedLead?.location?.settings)
        : selectedLead?.location?.settings;
    }
    return null;
  }, [selectedLead]);

  useEffect(() => {
    const temp = {};
    leadOpportunities?.forEach(op => {
      if (op?.id != null) temp[op.id] = true;
    });
    dispatch(setShowAll({ showAll: temp }));
  }, [selectedLead?.id]);

  useEffect(() => {
    setStatusId(selectedLead?.leadStatusTypeId);
  }, [selectedLead?.leadStatusTypeId]);

  useEffect(() => {
    setSelectedOpportunity(oppValue);
  }, [oppValue]);

  useEffect(() => {
    if (crmIntegrationType === CRM_TYPES.SALESFORCE) {
      if (
        leadOpportunities?.length > 0 &&
        leadOpportunities[0]?.sfLeadOpportunities?.length > 0 &&
        leadOpportunities[0]?.sfLeadOpportunities[0]?.sfOpportunityId
      ) {
        setIsSfOppr(true);
        setIsOpprOverall(true);
      } else {
        setIsSfOppr(false);
        setIsOpprOverall(false);
      }
    }
    if (crmIntegrationType === CRM_TYPES.DEALER_TEAM) {
      setIsOpprOverall(true);
    }
    if (crmIntegrationType === CRM_TYPES.DEALERSOCKET) {
      if (
        leadOpportunities?.length > 0 &&
        leadOpportunities[0]?.dsOpportunityEvents?.length > 0 &&
        leadOpportunities[0]?.dsOpportunityEvents[0]?.dsEventId
      ) {
        setIsDsOppr(true);
        setIsOpprOverall(true);
      } else {
        setIsDsOppr(false);
        setIsOpprOverall(false);
      }
    }
  }, [crmIntegrationType, selectedLead]);

  useEffect(() => {
    // crmIntegrationData can be undefined on the first render before
    // the lead detail query resolves — guard the spread so the
    // ``[...undefined]`` doesn't crash the tree.
    if (!Array.isArray(crmIntegrationData)) return;
    if (!isSFOppr) {
      const SFStatusList = [...crmIntegrationData];

      crmIntegrationData?.length > 0 && setlist([...uniqBy(SFStatusList, "status")]);
      setState(prev => !prev);
      crmIntegrationData?.length > 0 && setListTemp([...uniqBy(SFStatusList, "status")]);
    }

    if (crmIntegrationType === CRM_TYPES.DEALERSOCKET) {
      const SFStatusList = [...crmIntegrationData];
      crmIntegrationData?.length > 0 && setlist([...uniqBy(SFStatusList, "status")]);
      setState(prev => !prev);
    }
  }, [crmIntegrationData, isSFOppr, isDSOppr]);

  useEffect(() => {
    if (!Array.isArray(crmIntegrationData)) return;
    if (!isSFOppr && listTemp?.length > 0) {
      const SFStatusList = [...crmIntegrationData];

      setlist(prev => {
        const index =
          prev?.length > 0 && prev?.findIndex(item => +item?.statusTypeId === +statusId);
        if (index === -1) {
          const obj = SFStatusList?.find(item => +item.statusTypeId === +statusId);
          if (obj) {
            const dummyList = [...prev];
            const findIndexStatus = dummyList?.findIndex(item => item.status === obj.status);
            dummyList[findIndexStatus] = obj;
            return dummyList;
          }
        }
        return prev;
      });
    }
  }, [listTemp, isSFOppr, isDSOppr, statusId, crmIntegrationData]);

  useEffect(() => {
    if (crmIntegrationType === CRM_TYPES.SALESFORCE && isSFOppr) {
      const sfStageName =
        selectedLead?.leadOpportunities[0]?.sfLeadOpportunities[0]?.sfOpportunityStage;
      setStatusId("2");
      setlist([...SFOpprStatus, { statusTypeId: "2", status: sfStageName }]);
    }
  }, [isDSOppr, isSFOppr, selectedLead?.leadStatusTypeId]);

  const handleOpportunityStatusUpdation = async (oppStatus, opportunity) => {
    // return console.log(oppStatus, opportunity);
    const opporResp = await updateLeadOpportunity({
      variables: {
        leadOpportunityId: opportunity.id,
        opportunityStatusId: oppStatus,
      },
    });
    if (opporResp.data.updateLeadOpportunity.statusCode === 200) {
      message.success(opporResp?.data.updateLeadOpportunity.message);
      refetchLeadDetails();
      setConfirmModalOpen(false);
    } else {
      message.error(opporResp?.data.updateLeadOpportunity.message);
    }
  };

  const handleOpportunityName = oppr => {
    let opprName = oppr?.name;
    // DS
    if (
      (oppr?.dsOpportunityEvents?.length > 0 && oppr?.dsOpportunityEvents[0]?.dsEventId) ||
      crmLeadObj?.dsExtractedLead?.dsLeadId
    ) {
      opprName =
        oppr &&
        oppr?.dsOpportunityEvents &&
        oppr?.dsOpportunityEvents.length > 0 &&
        oppr?.dsOpportunityEvents[0]?.dsEventId
          ? `${lang.delearSocketOpprId} - ${oppr?.name}`
          : oppr?.name;
    }
    // SF
    if (
      (oppr?.sfLeadOpportunities?.length > 0 && oppr?.sfLeadOpportunities[0]?.sfOpportunityId) ||
      crmLeadObj?.sfExtractedLead?.sfLeadId
    ) {
      opprName = oppr?.sfLeadOpportunities[0]?.sfOpportunityId
        ? oppr?.name
        : `${lang.lead}: ${leadFullname}`;
    }
    return opprName;
  };

  const handlePushToDms = async opportunity => {
    try {
      const response = await pushOpportunityToDms({
        variables: {
          leadId: selectedLead.id,
          leadOpportunityId: opportunity.id,
        },
      });

      if (response.data?.pushToDms?.statusCode === 200) {
        message.success(
          "This Lead opportunity sync to DMS has been initiated successfully. The process will complete shortly."
        );
        // Optionally refetch data to update UI
        if (refetchLeads) {
          refetchLeads();
        }
      } else {
        message.error(
          response.data?.pushToDms?.message ||
            "Failed to push opportunity to DMS. Please try again."
        );
      }
    } catch (error) {
      console.error("Error pushing opportunity to DMS:", error);
      message.error("An error occurred while pushing opportunity to DMS. Please try again.");
    }
  };

  const GetCrmTypeName = () => {
    const crmTypeName =
      crmIntegrationType === CRM_TYPES.DEALERSOCKET
        ? lang.dealerSocket
        : crmIntegrationType === CRM_TYPES.DEALER_TEAM
        ? lang.dealerteam
        : crmIntegrationType === CRM_TYPES.SALESFORCE
        ? lang.salesforce
        : crmIntegrationType === CRM_TYPES.VIN_SOLUTIONS
        ? lang.vinSolutions
        : crmIntegrationType === CRM_TYPES.EL
        ? lang.ELead
        : crmIntegrationType === CRM_TYPES.MOMENTUM
        ? lang.Momentum
        : crmIntegrationType === CRM_TYPES.ADF
        ? lang.ADF
        : crmIntegrationType === CRM_TYPES.TEKION
        ? CRM_TYPE_LABELS[CRM_TYPES.TEKION]
        : "";
    return <Tooltip title={crmTypeName}>{crmTypeName}</Tooltip>;
  };

  const handleStatusChangeSfOppr = async (oppStatus, opportunityItem) => {
    // eslint-disable-next-line no-unused-vars
    const leadStage = selectedLead?.leadOpportunities[0];
    const stageRes = await updateSFStage({
      variables: {
        leadOpportunityId: opportunityItem?.id,
        stageName: "Duplicate",
      },
    });
    if (stageRes?.data?.updateSfLeadStage?.statusCode !== 200) {
      message.error(stageRes?.data?.updateSfLeadStage?.message);
    } else {
      message.success(stageRes?.data?.updateSfLeadStage?.message);
      refetchLeads();
    }
  };

  const getAPIHandler = (oppStatus, opportunityItem) => {
    if (crmIntegrationType === CRM_TYPES.DEALERSOCKET || settings?.IS_PUSH_TO_DMS) {
      return handleOpportunityStatusUpdation(oppStatus, opportunityItem);
    }

    if (crmIntegrationType === CRM_TYPES.SALESFORCE) {
      if (isSFOppr) {
        return handleStatusChangeSfOppr(oppStatus, opportunityItem);
      }
      return handleOpportunityStatusUpdation(oppStatus, opportunityItem);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const renderLabel = () => {
    if (crmIntegrationType === CRM_TYPES.SALESFORCE) {
      if (isSFOppr) {
        return lang.changeStage;
      }
    }
    return lang.changeStatus;
  };

  // TODO: Add location from the opportunity Object of the lead
  /**
   * The owners to show for a card: its own, or what the merge recorded.
   *
   * A merge re-points owner rows onto the surviving opportunity, so an archived
   * source revealed by "Show merged records" has none of its own and its Owners
   * section renders blank. The snapshot is reshaped into the nested form
   * `handleOwnerName` already reads rather than teaching that function a second
   * shape — it is shared with the live cards.
   */
  const ownersForRow = record => {
    const own = record?.leadOpportunityUsers || [];
    if (own.length > 0) return own;
    return (record?.mergeSnapshot?.owners || []).map(owner => ({
      id: owner.id,
      user: { fullName: owner.fullName, companyRole: { name: owner.companyRole } },
      userType: { name: owner.userType },
    }));
  };

  const handleOwnerName = opprUsers => {
    return (
      <div className="flex flex-wrap gap-1 text-sm text-grey-700 font-[400]">
        {(opprUsers || []).map((item, i) => {
          const companyRole = item?.user?.companyRole?.name;
          const userType = item?.userType?.name;

          let roleInfo = "";
          if (companyRole && userType) {
            roleInfo = ` (${companyRole} - ${userType})`;
          } else if (companyRole) {
            roleInfo = ` (${companyRole})`;
          } else if (userType) {
            roleInfo = ` (${userType})`;
          }

          return <p key={`owner0key-${i}`}>{`${item?.user?.fullName}${roleInfo}`}</p>;
        })}
      </div>
    );
  };

  // Map of opportunity type ID -> statuses for that type
  const [opportunityStatusMap, setOpportunityStatusMap] = useState({});
  const [opportunityTypes, setOpportunityTypes] = useState([]);

  // Fetch opportunity types with cache
  useQuery(GET_OPPORTUNITTIES_TYPES, {
    variables: {
      industryId: 1,
    },
    fetchPolicy: "cache-first",
    onCompleted: res => {
      setOpportunityTypes(res.getOpportunityTypes || []);
    },
  });

  // Helper: Get topmost parent ID for given opportunity type
  const getTopmostParentId = typeId => {
    if (!typeId || !opportunityTypes.length) return null;

    let currentId = typeId;
    let currentType = opportunityTypes.find(type => +type.id === +typeId);

    while (currentType?.parentType?.id) {
      const parentId = currentType.parentType.id;
      currentId = parentId;
      currentType = opportunityTypes.find(type => +type.id === +parentId);
    }

    return currentId;
  };

  // Get all unique opportunity type IDs from lead opportunities
  const uniqueOpportunityTypeIds = useMemo(() => {
    if (!leadOpportunities?.length) return [];
    const typeIds = leadOpportunities.map(opp => opp?.opportunityTypeId).filter(Boolean);
    return [...new Set(typeIds)];
  }, [leadOpportunities]);

  // Helper to get statuses for a specific opportunity type
  const getStatusesForOpportunityType = typeId => {
    if (!typeId) return [];
    return opportunityStatusMap[typeId] || [];
  };

  const handleStatusChangeWithConfirmation = (selectedId, item) => {
    if (!selectedId) return;

    // Find the status name from the opportunity status list for this item's type
    const statusList = getStatusesForOpportunityType(item?.opportunityTypeId);
    const statusName = statusList.find(status => status.id === selectedId)?.name || "this status";

    Modal.confirm({
      title: "Confirm Status Change",
      content: `Are you sure you want to change the opportunity status to "${statusName}"?`,
      okText: "Yes",
      cancelText: "No",
      onOk() {
        getAPIHandler(selectedId, item);
      },
      onCancel() {
        // Do nothing - user cancelled the change
      },
    });
  };

  // Helper function to flatten the nested tree structure to flat array with parentStatusId
  const flattenStatusTree = (nodes, parentId = null) => {
    let flattened = [];
    nodes.forEach(node => {
      flattened.push({
        id: node.key,
        name: node.name,
        isDefault: node.isDefault,
        parentStatusId: parentId,
      });
      if (node.childs && node.childs.length > 0) {
        flattened = flattened.concat(flattenStatusTree(node.childs, node.key));
      }
    });
    return flattened;
  };

  // Lazy query for fetching opportunity status
  const [getOpportunityStatus, { loading: opportunityStatusLoader }] = useLazyQuery(
    GET_OPPORTUNITY_STATUS_NEW,
    {
      fetchPolicy: "cache-first",
    }
  );

  // Fetch opportunity status when opportunity types are loaded
  useEffect(() => {
    const fetchStatusForType = async (typeId, locationIds) => {
      // Try: topmost parent → type itself → fallback to 1
      const idsToTry = [getTopmostParentId(typeId), typeId, 1].filter(Boolean);

      for (const id of idsToTry) {
        // eslint-disable-next-line no-await-in-loop
        const result = await getOpportunityStatus({
          variables: { opportunityTypeId: id, locationIds },
        });
        if (result.data?.getOpportunityStatusNew?.length > 0) {
          return flattenStatusTree(result.data.getOpportunityStatusNew);
        }
      }
      return [];
    };

    const fetchOpportunityStatus = async () => {
      if (!opportunityTypes.length || !uniqueOpportunityTypeIds.length) return;

      // Scope to the lead's own location — under "All locations" the session
      // holds every location id and each location has its own copy of the
      // statuses, so the cascader would list every name once per location
      // (EAI-1940). Fall back to the selector only if the lead has no location.
      const leadLocationId = selectedLead?.location?.id || selectedLead?.locationId;
      const locationIds = leadLocationId
        ? [+leadLocationId]
        : sessionStorage
            ?.getItem("currentLocationId")
            ?.split(",")
            .map(id => +id);

      const statusMap = {};
      for (const typeId of uniqueOpportunityTypeIds) {
        // eslint-disable-next-line no-await-in-loop
        statusMap[typeId] = await fetchStatusForType(typeId, locationIds);
      }
      setOpportunityStatusMap(statusMap);
    };

    fetchOpportunityStatus();
  }, [uniqueOpportunityTypeIds, opportunityTypes, selectedLead?.location?.id]);

  // Rows appended by "Show All" are tagged with this so Close can remove exactly
  // them. Matching by id instead is unreliable: the same opportunity can already
  // be in the list, and Close would delete that original rather than the
  // appended copy — shrinking the list, changing which opportunity is most
  // recent, flipping the default tab and refetching messagesV2 on a plain
  // collapse.
  const removeMergedOpportunity = (parentOpportunityId, opportunities) => {
    const updatedOpportunities = (opportunities || []).filter(
      opp => opp?.[MERGED_PREVIEW_OF] !== parentOpportunityId
    );
    if (updatedOpportunities.length === (opportunities || []).length) return;
    setSelectedLead({ ...selectedLead, leadOpportunities: updatedOpportunities });
  };

  const getMergedOpportunity = async (item, ids, opportunities) => {
    const duplicateOpportunities = await getLeadOpportunities({
      variables: {
        leadOpportunityIds: ids,
      },
    });

    // Tag each appended row with the parent it was expanded under, so Close
    // removes these copies and never a pre-existing entry with the same id.
    const temp = (duplicateOpportunities.data?.getLeadOpportunitiesById || []).map(opp => ({
      ...opp,
      [MERGED_PREVIEW_OF]: item.id,
    }));

    const index = opportunities.findIndex(opportunity => opportunity.id === item.id);

    if (index === -1) {
      return;
    }

    // Create a new array with the temp array added after the matching lead
    const updatedOpportunities = [
      ...opportunities.slice(0, index + 1), // All leads up to the matching lead (inclusive)
      ...temp, // Add the temp array after the matching lead
      ...opportunities.slice(index + 1), // The rest of the leads
    ];

    setSelectedLead({ ...selectedLead, leadOpportunities: updatedOpportunities });
  };

  const handleOpportunityOptions = (key, item) => {
    switch (key) {
      case "edit":
        setopportunityDrawer({ open: true, item });
        break;
      case "viewInChat":
        dispatch(changeMessageOpportunity(item.id));
        break;
      default:
        break;
    }
  };

  const canUserReassessment = checkAccessPermission(
    AccessPermissionAction.LEAD_MANAGEMENT_USER_REASSIGNMENT
  );

  const handleReassignOpportunity = opportunity => {
    setReassignDrawer({
      open: true,
      opportunity: opportunity,
    });
  };

  const renderActions = item => {
    // An archived source revealed by "Show merged records" is history. Editing
    // it would write to a record the merge retired, and pinning the thread to
    // it would scope the conversation to an opportunity that no longer holds
    // the messages - the merge moved those onto the surviving record.
    if (item?.[MERGED_PREVIEW_OF]) return null;

    return (
      <div className="gap-4 flex-row-centered">
        <Tooltip title="Edit Opportunity">
          <LuPencil
            size={16}
            strokeWidth={1.75}
            className="cursor-pointer mr-1 text-twLinkColor"
            onClick={() => setopportunityDrawer({ open: true, item })}
          />
        </Tooltip>
        <Checkbox
          onChange={e => {
            if (e.target.checked) {
              // Pin to this specific opportunity AND sync the active root
              // tab to match it — without this, TopToolbarJsx's chip
              // keeps showing the PREVIOUSLY active root's icon whenever
              // this opp belongs to a different root than the current tab.
              dispatch(changeMessageOpportunity(item.id));
              if (typeof setSelectedOppTypeId === "function") {
                setSelectedOppTypeId(getRootOppTypeId(item?.opportunityType));
              }
            } else {
              // Unpinning goes to "All opportunity" (no opp/root scoping
              // at all) rather than "All <root>" — matches the dropdown's
              // own top-level "All opportunity" option.
              dispatch(changeMessageOpportunity(ALL_OPPORTUNITY_TYPES_ID));
              if (typeof setSelectedOppTypeId === "function") {
                setSelectedOppTypeId(null);
              }
            }
          }}
          checked={+messageOpportunity === +item.id}
        />
      </div>
    );
  };

  const getOpportunitySourceUser = opportunity => {
    const activeOwner = opportunity?.leadOpportunityUsers?.find(u => u.isActive);
    if (activeOwner?.user) {
      const name = activeOwner.user.fullName || "Unknown";
      const role = activeOwner.userType?.name || activeOwner.user.companyRole?.name || "";
      return {
        value: activeOwner.user.id,
        label: role ? `${name} (${role})` : name,
        companyId: activeOwner.user.companyId,
        locationId: selectedLead?.location?.id || selectedLead?.locationId,
      };
    }
    return null;
  };

  const handleReassignDrawerClose = () => {
    setReassignDrawer({
      open: false,
      opportunity: null,
    });
  };

  const handleReassignRefetch = () => {
    refetchLeadDetails();
    handleReassignDrawerClose();
  };

  const canMergeOppor = checkAccessPermission(AccessPermissionAction.MERGE_LEADS_OPPS);

  // Visible Sales / Service / Parts tabs for this lead × user. Derived
  // from the lead's opportunities (must have at least one of that root
  // type) intersected with the user's UserDepartment permissions.
  // Filter cards by active tab. ``selectedOppTypeId`` null ⇒ show
  // everything (legacy / no tab strip case). When a tab IS active,
  // include only opps whose root opp_type matches. The tab strip itself
  // moved up to ``LeadProfile`` (``OppTypeRootTabs``) so the same tab
  // scopes Notes, Tasks, Appointments, and Opportunities in one place.
  const tabFilteredOpportunities = selectedOppTypeId
    ? (leadOpportunities || []).filter(opp => oppMatchesTab(opp, selectedOppTypeId))
    : leadOpportunities || [];

  /**
   * EAI-1815: a flagged duplicate is folded into its anchor card — whose
   * banner names it and offers the merge — so it doesn't also get a card of
   * its own. Filtering happens HERE, on the local list that only feeds the
   * ``List`` below, deliberately: mutating ``selectedLead.leadOpportunities``
   * instead would change which opportunity is most recent, flipping the
   * default opp-type tab and refetching messagesV2 (see MERGED_PREVIEW_OF).
   */
  const hiddenDuplicateIds = useMemo(
    () =>
      // Rows injected by "Show All" are excluded from the calculation
      // entirely: they are archived sources the user asked to see, so they
      // must neither be hidden nor cause a real card to be hidden.
      getHiddenDuplicateIds(
        tabFilteredOpportunities.filter(opp => opp?.[MERGED_PREVIEW_OF] === undefined)
      ),
    [tabFilteredOpportunities]
  );

  const listedOpportunities = tabFilteredOpportunities.filter(
    // A row injected by "Show All" is always kept — explicitly requested.
    opp => opp?.[MERGED_PREVIEW_OF] !== undefined || !hiddenDuplicateIds.has(+opp?.id)
  );

  return (
    <div>
      <List
        itemLayout="vertical"
        className="py-1 px-0"
        dataSource={orderBy(
          listedOpportunities || [],
          item => new Date(item?.updatedDate || item?.createdDate || 0),
          "desc"
        )}
        pagination={
          // Count what's actually listed, so hiding duplicates can also drop
          // a paginator that's no longer needed.
          listedOpportunities?.length <= 7
            ? false
            : {
                onChange: () => {},
                pageSize: 7,
                size: "small",
              }
        }
        renderItem={(item, i) => {
          const {
            crmLink: feResolvedCrmLink,
            isOpportunity,
            label: opprLabel,
            fullLabel: opprFullLabel,
          } = getOpprDetails({
            opportunity: item,
            crmLeadObj: selectedLead?.crmLeadObj,
            selectedLead,
          });
          // Prefer the BE-resolved URL (api/utils/crm_links.py) so we
          // cover every supported CRM (DS / SF / DT / VIN / EL / TK)
          // without the FE re-implementing each template. The BE
          // returns "" when it can't resolve one (e.g. Momentum, or a
          // missing CRM id), in which case we fall back to the legacy
          // FE-side ``crmLinkGeneration`` result above.
          const crmLeadOpportunityLink = item?.crmUrl || feResolvedCrmLink;

          // An opportunity is never its own duplicate. Guarding here because
          // the BE's OpportunityPotentialDuplicateLoader returns its results
          // ordered by id DESC rather than in requested-key order, so a list
          // can land on the wrong card — without this, that surfaces as a
          // banner naming the very opportunity it sits on.
          const duplicateOpportunityIds = (item?.potentialOpportunity || []).filter(
            duplicateId => +duplicateId !== +item?.id
          );

          // CRM-formatted ids for the duplicate warning, e.g. "DS 1471522".
          // `potentialOpportunity` only carries raw internal ids, but every
          // duplicate belongs to the SAME lead, so the full (untabbed)
          // `leadOpportunities` already holds the record — no extra fetch.
          // Reuses `getOpprDetails` so a duplicate is labelled exactly as its
          // own card titles it.
          const duplicateOpportunityLabels = duplicateOpportunityIds
            .map(duplicateId => {
              const duplicate = (leadOpportunities || []).find(opp => +opp?.id === +duplicateId);
              return duplicate
                ? getOpprDetails({
                    opportunity: duplicate,
                    crmLeadObj: selectedLead?.crmLeadObj,
                    selectedLead,
                  })?.label
                : null;
            })
            .filter(Boolean);

          // Name the duplicates in the warning itself, using the same id the
          // opportunity's own title shows (e.g. "EAI 57707"), so the card says
          // WHICH record it collides with without opening the drawer.
          // Falls back to the plain sentence when none of the ids resolve to a
          // loaded record — e.g. a duplicate scoped out by the opp-type tab —
          // rather than naming something the user cannot see.
          const duplicateBannerLabel = duplicateOpportunityLabels.length ? (
            <>
              {`${lang.duplicateOpportunityFoundWithIds} `}
              <span className="font-semibold">{duplicateOpportunityLabels.join(", ")}</span>.
            </>
          ) : (
            lang.duplicateOpportunityFound
          );

          const leadSourceName = getLeadOpportunitySource(item?.opportunitySource || {});

          const opportunityStatus = getLeadOpportunityStatus(item);

          const opportunityCoBuyers =
            item?.leadOpportunityContacts?.filter(
              coBuyer => coBuyer?.leadId !== selectedLead?.id
            ) || [];

          return (
            <div className="mb-1">
              <div
                style={{
                  // Pink marks an archived source revealed by "Show merged
                  // records", so what the merge swallowed stays distinct from
                  // live records while scrolling. The record a merge *produced*
                  // gets no tint — its banner already says so. Selection
                  // outranks the tint, so clicking one looks like clicking any
                  // other card.
                  // The default white lives here rather than in a `bg-white`
                  // class: Tailwind runs with `important: true`, so a class
                  // would win over this inline value and no tint would ever
                  // show (which is exactly what used to happen).
                  backgroundColor:
                    selectedOpportunity === item.id
                      ? "#eff6ff"
                      : item?.[MERGED_PREVIEW_OF]
                      ? MERGED_PREVIEW_BG
                      : "#fff",
                }}
                className={`relative p-3 w-full flex flex-col items-start justify-start gap-3 border border-solid ${
                  +messageOpportunity === +item.id ? "border-brand-500" : "border-grey-200"
                } rounded-[4px]`}
              >
                {/* Root opp_type indicator pinned to the card's
                    top-right corner. Mirrors the same color/icon tokens
                    the right-side tabs and lead-list rows use. */}
                <OppTypeCardCornerIcon opp={item} />
                <div className="flex-col-centered gap-1 max-w-full w-full">
                  {/* pr-6 keeps the title row clear of the 20px corner
                      opp-type icon (top-right) — without it long opp
                      names overlap the chip in narrow layouts like the
                      browser extension. The full text is still
                      reachable via the Tooltip on hover. */}
                  <div className="flex-row-centered gap-2 ellipsis w-full max-w-full min-w-0 pr-6">
                    <div
                      onClick={e => e.stopPropagation()}
                      className="idColor flex flex-row items-center text-align-start min-w-0 flex-shrink-0"
                    >
                      {crmLeadOpportunityLink ? (
                        <a
                          className="labelColor"
                          target="_blank"
                          rel="noreferrer"
                          href={crmLeadOpportunityLink}
                        >
                          <Tooltip title={opprFullLabel}>
                            <span className="line-clamp-1 block">{opprLabel}</span>
                          </Tooltip>
                        </a>
                      ) : (
                        isOpportunity && (
                          <Tooltip title={opprFullLabel}>
                            <p className="labelColor font-semibold">{opprLabel}</p>
                          </Tooltip>
                        )
                      )}
                    </div>
                    <Tooltip title={handleOpportunityName(item)}>
                      <div className="flex-row-centered gap-1 min-w-0 truncate">
                        <div className="p-0.5 rounded-full bg-grey-500 flex-shrink-0" />
                        <span className="truncate">{handleOpportunityName(item)}</span>
                      </div>
                    </Tooltip>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs font-[400] text-grey-500">
                      {/* The opportunity's own location first, the lead's only
                          as a fallback. Rows fetched by id - the archived
                          sources behind "Show merged records" - carry
                          `location` directly and no `lead` object at all, so
                          reading through `lead` showed them all as "N/A". */}
                      {item?.location?.title || item?.lead?.location?.title || "N/A"}
                    </span>
                    <span className="text-xs font-[400] text-grey-500">
                      Created at:{" "}
                      {convertUtcToLocal(
                        item.createdDate,
                        DATE_TIME_FORMATS.MMM_DD_YYYY_COMMA_hh_mm_A
                      )}
                    </span>
                    <span className="text-xs font-[400] text-grey-500">
                      Updated at:{" "}
                      {convertUtcToLocal(
                        item.updatedDate,
                        DATE_TIME_FORMATS.MMM_DD_YYYY_COMMA_hh_mm_A
                      )}
                    </span>
                  </div>
                </div>
                <div className="flex-col-centered gap-4 w-full">
                  <div className="flex-col-centered items-start gap-1">
                    <span className="text-xs font-[600] text-grey-700">Source:</span>
                    <span>{leadSourceName}</span>
                  </div>
                  <div className="flex-col-centered items-start gap-1">
                    <span className="text-xs font-[600] text-grey-700">Vehicles:</span>
                    <VehicleJSX item={item} />
                  </div>
                  {/* A merge moves owner rows onto the surviving record and
                      parks only the duplicates back here, so an archived source
                      can legitimately have none. Drop the heading in that case
                      rather than leaving "Owners:" over empty space, which
                      reads as a failed load. */}
                  {ownersForRow(item).length > 0 && (
                    <div className="flex-col-centered items-start gap-1">
                      <div className="flex flex-row items-center justify-between w-full">
                        <span className="text-xs font-[600] text-grey-700">Owners:</span>
                        {canUserReassessment && (
                          <Tooltip title="Re-assign opportunity">
                            <Button
                              type="link"
                              size="small"
                              className="p-0 h-auto text-xs text-blue-500 hover:text-blue-600 align-self-end cursor-pointer"
                              onClick={e => {
                                e.stopPropagation();
                                handleReassignOpportunity(item);
                              }}
                            >
                              Re-assign
                            </Button>
                          </Tooltip>
                        )}
                      </div>
                      <span>{handleOwnerName(ownersForRow(item), crmIntegrationType)}</span>
                    </div>
                  )}
                </div>
                <div className="flex-row-centered w-full justify-between gap-2">
                  {allowChangeStatus &&
                  (crmIntegrationType === CRM_TYPES.SALESFORCE ||
                    crmIntegrationType === CRM_TYPES.DEALER_TEAM ||
                    crmIntegrationType === CRM_TYPES.DEALERSOCKET ||
                    settings?.IS_PUSH_TO_DMS) ? (
                    <div className="flex-row-centered gap-1 min-w-0 flex-1 overflow-hidden">
                      <span className="text-xs font-[600] text-grey-700 flex-shrink-0">
                        Status:
                      </span>
                      <OpportunityStatusCascader
                        leadStatusList={getStatusesForOpportunityType(item?.opportunityTypeId)}
                        // Disabled, not hidden, on an archived source revealed
                        // by "Show merged records": the status it was left with
                        // is part of the history worth seeing, but changing it
                        // would write to a record the merge retired.
                        canAddEditOpportunity={!item?.[MERGED_PREVIEW_OF]}
                        expandTrigger="hover"
                        opportunityStatusLoader={opportunityStatusLoader}
                        value={item?.opportunityStatusId || item?.opportunityStatus?.id || null}
                        onChange={selectedId => {
                          handleStatusChangeWithConfirmation(selectedId, item);
                        }}
                        statusHistory={
                          settings?.SKIP_OPPORTUNITY_STATUS_HISTORY_CREATION
                            ? item?.statusHistory || []
                            : []
                        }
                        showStatusIcons={!!settings?.SKIP_OPPORTUNITY_STATUS_HISTORY_CREATION}
                        size="small"
                        style={{
                          fontSize: "12px",
                          minWidth: 0,
                          maxWidth: "100%",
                        }}
                        className="w-full"
                        displayRender={(_labels, selectedOptions) => {
                          if (!selectedOptions?.length) {
                            return (
                              <Tooltip title={opportunityStatus}>
                                <span className="opportunity-status-text">{opportunityStatus}</span>
                              </Tooltip>
                            );
                          }
                          const lastOption = selectedOptions[selectedOptions.length - 1];
                          const iconData = settings?.SKIP_OPPORTUNITY_STATUS_HISTORY_CREATION
                            ? lastOption?.statusIconDisplay
                            : null;
                          const textPath = selectedOptions
                            .map(o => o.textLabel || o.label)
                            .join(" / ");
                          return (
                            <Tooltip title={textPath}>
                              <span className="opportunity-status-text">
                                {iconData && (
                                  <img
                                    src={iconData.iconSrc}
                                    alt={iconData.iconAlt}
                                    style={{ width: 14, height: 14, flexShrink: 0 }}
                                  />
                                )}
                                <span className="opportunity-status-text__label">{textPath}</span>
                              </span>
                            </Tooltip>
                          );
                        }}
                        allowParentSelection={crmIntegrationType === CRM_TYPES.DEALERSOCKET}
                      />
                    </div>
                  ) : (
                    <div className="flex-row-centered gap-1 min-w-0 flex-1 overflow-hidden">
                      <span className="text-xs font-[600] text-grey-700 flex-shrink-0">
                        Status:
                      </span>
                      <Tooltip title={opportunityStatus}>
                        <span className="opportunity-status-text">{opportunityStatus}</span>
                      </Tooltip>
                    </div>
                  )}
                  {!settings?.IS_PUSH_TO_DMS && renderActions(item)}
                </div>
                {!isEmpty(opportunityCoBuyers) && <CustomDivider className="!my-0" />}
                {/* {!isEmpty(opportunityCoBuyers) ? (
                  opportunityCoBuyers?.map(coBuyer => (
                    <CoBuyerCard key={coBuyer.leadId} coBuyer={coBuyer} />
                  ))
                ) : (
                  <CustomButton
                    btnText="Add Co-Buyer"
                    type="link"
                    className="!p-0"
                    icon={<PlusCircleFilled />}
                    handleClick={() => setCoBuyerDrawerOpen(true)}
                  />
                )} */}
                {!isEmpty(opportunityCoBuyers) &&
                  opportunityCoBuyers?.map(coBuyer => (
                    <CoBuyerCard key={coBuyer.leadId} coBuyer={coBuyer} />
                  ))}
                {!isEmpty(opportunityCoBuyers) &&
                  settings?.IS_PUSH_TO_DMS &&
                  !item?.[MERGED_PREVIEW_OF] && <CustomDivider className="!my-0" />}

                {/* Nothing in this row applies to an archived source: the
                    merge already moved its rows onto the surviving
                    opportunity, so pushing it would send the DMS a retired
                    record, and its actions are gone with `renderActions`. */}
                {settings?.IS_PUSH_TO_DMS && !item?.[MERGED_PREVIEW_OF] && (
                  <div className="flex-row-centered w-full justify-between">
                    <div className="flex-row-centered w-[150px]">
                      <Button
                        type="primary"
                        className="flex-1 flex-row-centered items-center justify-center"
                        onClick={() => handlePushToDms(item)}
                        disabled={(item?.ziMajorUnitInvoices || []).length > 0}
                      >
                        <ExportOutlined /> Push to DMS
                      </Button>
                    </div>
                    <div className="flex-row-centered w-[50px]">{renderActions(item)}</div>
                  </div>
                )}
              </div>

              {/* Duplicate warning — shown only while the BE still reports
                  unmerged duplicates on this opportunity (EAI-1815). */}
              {duplicateOpportunityIds.length > 0 && (
                <DuplicateRecordsBanner
                  label={duplicateBannerLabel}
                  canMerge={canMergeOppor}
                  onMerge={() => setMergeOpportunity(item)}
                />
              )}
              {/* Merged-opportunity strip (EAI-1815). Informational, so it
                  takes the success treatment rather than the amber warning
                  above — and yields to it: a record can be both a merge result
                  and still have live duplicates, but two stacked strips is a
                  lot of chrome, and the actionable one should win. */}
              {duplicateOpportunityIds.length === 0 &&
                item?.opportunityMergeHistory?.length > 0 &&
                (() => {
                  // `showAll[id]` is undefined until first toggled, so
                  // anything but an explicit `false` means collapsed.
                  const isCollapsed = showAll?.[item?.id] !== false;

                  const toggleMergedList = () => {
                    if (isCollapsed) {
                      getMergedOpportunity(item, item?.opportunityMergeHistory, leadOpportunities);
                    } else {
                      removeMergedOpportunity(item?.id, leadOpportunities);
                    }

                    dispatch(
                      setShowAll({
                        showAll: { ...(showAll || {}), [item?.id]: !isCollapsed },
                      })
                    );
                  };

                  return (
                    <MergedRecordsBanner
                      label={lang.mergedOpportunityLabel}
                      expanded={!isCollapsed}
                      onToggle={toggleMergedList}
                    />
                  );
                })()}
              {settings?.IS_PUSH_TO_DMS && (item?.ziMajorUnitInvoices || []).length > 0 && (
                <div className="flex-row-centered w-full">
                  <Collapse
                    expandIcon={panelProps => (
                      <DownIcon
                        className={`${
                          panelProps.isActive ? "rotate-0" : "rotate-[-90deg]"
                        } transition-all duration-300`}
                      />
                    )}
                    className="w-full rounded-none"
                    size="small"
                  >
                    <Collapse.Panel
                      className="opportunity-sections"
                      key="invoice-details"
                      header={`Invoice Details (${(item?.ziMajorUnitInvoices || []).length})`}
                    >
                      <div className="space-y-3">
                        {/* Invoice 1 */}
                        {(item?.ziMajorUnitInvoices || []).map((invoice, idx) => {
                          const buyVehicles = (invoice?.ziMajorUnitInvoiceItems || [])?.filter(
                            item => item.leadVehicleOfInterest.customerInterest === "BUY"
                          );

                          const tradeVehicles = (invoice?.ziMajorUnitInvoiceItems || [])?.filter(
                            item => item.leadVehicleOfInterest.customerInterest === "TRADE"
                          );

                          return (
                            <div
                              key={`invoice-key-${idx}`}
                              className="relative bg-white border border-grey-200 rounded-lg p-3 shadow-sm cursor-pointer hover:shadow-md transition-shadow"
                              onClick={() =>
                                setInvoiceDrawer({
                                  open: true,
                                  invoiceData: invoice,
                                })
                              }
                            >
                              {(invoice?.ziDealStatus || invoice?.invoiceStatus?.name) && (
                                <span
                                  className="absolute top-2 right-2 text-xs px-2 py-1"
                                  style={{
                                    borderRadius:
                                      "var(--Components-Tag-Global-borderRadiusSM, 4px)",
                                    border:
                                      "var(--Components-Tag-Global-lineWidth, 1px) solid var(--Components-Tag-Global-colorBorder, #D9D9D9)",
                                    background:
                                      "var(--Components-Tag-Component-defaultBg, rgba(0, 0, 0, 0.02))",
                                    color:
                                      "var(--Components-Tag-Component-defaultColor, rgba(0, 0, 0, 0.88))",
                                  }}
                                >
                                  {invoice?.ziDealStatus || invoice?.invoiceStatus?.name || "N/A"}
                                </span>
                              )}

                              <div className="pr-16">
                                <span className="text-sm font-[600] text-black-600 block line-height-[20px]">
                                  {`Invoice #: ${(invoice?.ziDealNo || 0)
                                    .toString()
                                    .padStart(6, "0")}`}
                                </span>
                                <span
                                  className="text-sm block line-height-[28px] mb-2"
                                  style={{ color: "rgba(0, 0, 0, 0.88)" }}
                                >
                                  Total: ${(invoice?.invoiceTotal || 0).toFixed(2)}
                                </span>
                                {buyVehicles?.map(vehicleItem => {
                                  const vehicleName = getVehicleName(
                                    vehicleItem?.leadVehicleOfInterest
                                  );
                                  return (
                                    <span
                                      key={`buy-vehicle-key-${vehicleItem.id}`}
                                      className="text-xs block text-[12px] text-grey-600 line-height-[20px]"
                                    >
                                      <span className="text-blue-600 text-[12px]">(Buy)</span>{" "}
                                      {vehicleName}
                                    </span>
                                  );
                                })}
                                {tradeVehicles?.map(vehicleItem => {
                                  const vehicleName = getVehicleName(
                                    vehicleItem?.leadVehicleOfInterest
                                  );
                                  return (
                                    <span
                                      key={`trade-vehicle-key-${vehicleItem.id}`}
                                      className="block text-[12px] text-grey-600 line-height-[20px]"
                                    >
                                      <span className="text-orange-600 text-[12px]">(Trade)</span>{" "}
                                      {vehicleName}
                                    </span>
                                  );
                                })}

                                <span className="text-xs text-grey-400 mt-2 block line-height-[20px]">
                                  Updated on:{" "}
                                  {convertUtcToLocal(invoice.updatedAt, "MMM DD, YYYY, hh:mm A")}
                                </span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </Collapse.Panel>
                  </Collapse>
                </div>
              )}
              {/*
                "View N ROs" button — Service opps only. DS-only data
                today; BE exposes ``serviceRosCount`` on LeadOpportunity
                and returns 0 for non-service opps. Button hides on 0.
                Click handler shows the list as a Modal below — kept
                inline so each card is self-contained.
              */}
              {item?.serviceRosCount > 0 && (
                <div className="mt-2">
                  <Button
                    type="link"
                    size="small"
                    className="p-0 text-brand-500"
                    onClick={() => setViewRosForOppId(item.id)}
                  >
                    View {item.serviceRosCount} {item.serviceRosCount === 1 ? "RO" : "ROs"}
                  </Button>
                </div>
              )}
            </div>
          );
        }}
      />
      <OpportunityDrawer
        opportunityDrawer={opportunityDrawer}
        setopportunityDrawer={setopportunityDrawer}
        refetch={refetchLeadDetails}
        crmIntegrationType={crmIntegrationType}
        mode="EDIT"
        showCancel
        settings={settings}
        titleContent={
          <div className="flex flex-col">
            <span className="text-lg font-[600]">
              Modify Opportunity {opportunityDrawer?.item?.name || ""} for{" "}
              {selectedLead?.fullName || ""}
            </span>
            <span className="text-sm font-[400]">
              Provide the following details to modify the opportunity
            </span>
          </div>
        }
      />
      {opportunityWarningDialog && (
        <OpportunityWarning
          opportunityInfo={opportunityInfo}
          crmIntegrationType={crmIntegrationType}
          crmLeadObj={crmLeadObj}
          visibleModal={opportunityWarningDialog}
          handleOKBtn={() => setOpportunityWarningDialog(false)}
          setModalVisible={() => setOpportunityWarningDialog(false)}
          handleOpporDialogFlagChanged={handleOpporDialogFlagChanged}
        />
      )}
      {/*
        Repair Orders modal. DS-only data sourced from
        ``DsServiceEventVehiclesRo`` via the LeadOpportunity GraphQL
        type's ``serviceRos`` field. Renders nothing when there are no
        ROs (button shouldn't have been shown in that case anyway).
      */}
      {viewRosForOppId &&
        (() => {
          const opp = (leadOpportunities || []).find(o => +o.id === +viewRosForOppId);
          const ros = opp?.serviceRos || [];
          return (
            <Modal
              open={!!viewRosForOppId}
              title={`Repair Orders (${ros.length})`}
              onCancel={() => setViewRosForOppId(null)}
              footer={null}
              width={640}
            >
              {ros.length === 0 ? (
                <div className="text-grey-500 py-4 text-center">No repair orders found.</div>
              ) : (
                <List
                  dataSource={ros}
                  renderItem={ro => (
                    <List.Item className="!px-0">
                      <div className="w-full">
                        <div className="flex justify-between items-start">
                          <div>
                            <div className="font-[600] text-sm">RO #{ro.roNumber || "—"}</div>
                            <div className="text-xs text-grey-600">
                              {[ro.year, ro.make, ro.model].filter(Boolean).join(" ") ||
                                "Vehicle: —"}
                            </div>
                            {ro.vin && <div className="text-xs text-grey-500">VIN: {ro.vin}</div>}
                          </div>
                          <div className="text-right">
                            <Tag color={ro.roStatus === "CLOSED" ? "default" : "blue"}>
                              {ro.roStatusDesc || ro.roStatus || "—"}
                            </Tag>
                            {typeof ro.totalAmt === "number" && (
                              <div className="text-xs text-grey-600 mt-1">
                                ${(ro.totalAmt || 0).toFixed(2)}
                              </div>
                            )}
                          </div>
                        </div>
                        {ro.updateDate && (
                          <div className="text-xs text-grey-400 mt-1">
                            Updated: {convertUtcToLocal(ro.updateDate, "MMM DD, YYYY, hh:mm A")}
                          </div>
                        )}
                      </div>
                    </List.Item>
                  )}
                />
              )}
            </Modal>
          );
        })()}

      {/* Individual Opportunity Reassignment Drawer */}
      {reassignDrawer.open && (
        <OpportunityAssignmentDrawer
          open={reassignDrawer.open}
          onClose={handleReassignDrawerClose}
          selectedCount={1}
          selectedOpportunities={[reassignDrawer.opportunity]}
          onRefetch={handleReassignRefetch}
          sourceUser={getOpportunitySourceUser(reassignDrawer.opportunity)}
          locationSetting={settings}
        />
      )}

      {/* Invoice Details Drawer */}
      <InvoiceDetailsDrawer
        open={invoiceDrawer.open}
        onClose={() => setInvoiceDrawer({ open: false, invoiceData: null })}
        invoiceData={invoiceDrawer.invoiceData}
      />
      {coBuyerDrawerOpen && (
        <AddCoBuyerDrawer
          open={coBuyerDrawerOpen}
          onClose={() => setCoBuyerDrawerOpen(false)}
          onSave={() => setCoBuyerDrawerOpen(false)}
        />
      )}

      {/* Merge duplicate opportunities (EAI-1815) */}
      {mergeOpportunity && (
        <MergeOpportunityDrawer
          open={Boolean(mergeOpportunity)}
          onClose={() => setMergeOpportunity(null)}
          opportunity={mergeOpportunity}
          // The merge updates the kept record and archives the others, so the
          // card list has to come back from the server.
          // The merge posts a MERGE_OPPORTUNITY message server-side, so the
          // thread has to reload for it to appear — `refetchLeadDetails` alone
          // keeps the pre-merge messages. Mirrors the consent flow in
          // `leadProfile`, which reloads both for the same reason.
          onMerged={() => {
            refetchLeadDetails?.();
            getMessages?.();
          }}
        />
      )}
    </div>
  );
};
export default OpportunityLayer;

// function to get lead owner info , like redering on lead center for owners (Implementation is in progress)
export const handleOwnerData = (leadUsers, crmIntegration, isOpprOverall = false) => {
  let primaryOwnerName = "Select Owner";

  const ownerArray = leadUsers.map(user => {
    if (user?.userType?.name) {
      return {
        label: `${user?.userType?.name}`,
        username: `${user?.user?.firstName} ${user?.user?.lastName} ${
          user?.user?.companyRole?.name ? `(${user?.user?.companyRole?.name})` : ""
        }`,
        id: user?.userType?.id,
      };
    }

    return {
      label: "",
      username: `${user?.user?.firstName} ${user?.user?.lastName} ${
        user?.user?.companyRole?.name ? `(${user?.user?.companyRole?.name})` : ""
      }`,
      id: "",
    };
  });
  if (crmIntegration === CRM_TYPES.SALESFORCE) {
    let ownerArraySF = [];

    if (isOpprOverall) {
      ownerArraySF = ["opportunity owner", "salesperson 1", "salesperson 2"];
    } else {
      ownerArraySF = ["lead owner", "salesperson 1", "bdc rep"];
    }

    let isFoundSF = false;
    for (const ownerLabel of ownerArraySF) {
      for (const owner of ownerArray) {
        if (owner?.label?.toLowerCase() === ownerLabel) {
          primaryOwnerName = owner?.username;
          isFoundSF = true;
          break;
        } else {
          primaryOwnerName = owner?.username;
        }
      }
      if (isFoundSF) break;
    }
  } else if (crmIntegration === CRM_TYPES.DEALERSOCKET) {
    const ownerArray1 = ["primary assigned", "bdc", "secondary assigned"];
    let isFound = false;
    for (const ownerLabel of ownerArray1) {
      for (const owner of ownerArray) {
        if (owner?.label?.toLowerCase() === ownerLabel) {
          primaryOwnerName = owner?.username;
          isFound = true;
          break;
        } else {
          primaryOwnerName = owner?.username;
        }
      }
      if (isFound) break;
    }
  }

  return primaryOwnerName;
};

function VehicleJSX({ item }) {
  const vehicleOfInterest = getUniqueVehicleOfInterest(item?.vehiclesOfInterest);

  return (
    <div className="flex flex-col items-start justify-start gap-1">
      {vehicleOfInterest?.length > 0 ? (
        vehicleOfInterest?.map((voi, index) => {
          const parseVehicles = () => {
            // A YMM part is only meaningful if it isn't empty/zero AND isn't a
            // placeholder like "unknown" — the BE sends literal "unknown" for
            // missing make/model, which previously rendered as "unknown unknown".
            const isValidVoiPart = v => {
              if (v === null || v === undefined) return false;
              const s = String(v).trim().toLowerCase();
              return s !== "" && s !== "0" && s !== "unknown";
            };

            let name = "";
            if (isValidVoiPart(voi?.year)) {
              name = `${name} ${voi.year}`;
            }

            if (isValidVoiPart(voi?.make)) {
              name = `${name} ${voi.make}`;
            }

            if (isValidVoiPart(voi?.model)) {
              name = `${name} ${voi.model}`;
            }

            // Drop invalid YMM (e.g. make/model came back as "unknown") so we
            // never render "N/A"/"unknown unknown". But interest is meaningful
            // on its own — show it even when YMM is missing:
            //   YMM + interest -> "2022 Ford F150 (Buy)"
            //   YMM only       -> "2022 Ford F150"
            //   interest only  -> "(Buy)"
            //   neither        -> "" (renders nothing)
            name = name.trim();
            const customerInterest = capitalize(voi?.customerInterest || "");
            let voiName = name;
            if (customerInterest !== "") {
              voiName = name !== "" ? `${name} (${customerInterest})` : `(${customerInterest})`;
            }

            const vehicleInfo = (
              <div>
                <p>{voiName}</p>
                <p className="mt-3">Stock: {voi?.stockNumber ? `#${voi?.stockNumber}` : "N/A"}</p>
                <p>VIN: {voi?.vin || "N/A"}</p>
              </div>
            );

            if (voiName.trim() !== "") {
              return (
                <Tooltip placement="topLeft" title={vehicleInfo}>
                  <Tag
                    color={
                      voi?.customerInterest === "TRADE"
                        ? "orange"
                        : voi?.customerInterest === "SELL"
                        ? "magenta"
                        : voi?.customerInterest === "BUY"
                        ? "blue"
                        : voi?.customerInterest === "SERVICE"
                        ? "purple"
                        : "magenta"
                    }
                    style={{
                      maxWidth: "100%",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                    }}
                  >
                    {voiName}
                  </Tag>
                </Tooltip>
              );
            }
            // No meaningful vehicle info -> render nothing for this entry.
            return null;
          };
          return (
            <div className="test-start" key={index}>
              {parseVehicles()}
            </div>
          );
        })
      ) : (
        <span>No Vehicles</span>
      )}
    </div>
  );
}
